import type { PartnerFulfillmentContextDomainCountries } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const fulfillmentContextDomains = {
  search: {
    queryKey: 'partner-management-service/fulfillment-context-domains',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerFulfillmentContextDomainCountries[]>(
        '/partner-management-proxy/api/v1/partners/fulfillmentContextDomains',
      );

      return data;
    },
  },
};
